export enum AnalyticName {
  sowing = 'sowing',
  weeds = 'weeds'
}
export type AnalyticNameType = AnalyticName.sowing | AnalyticName.weeds;
